<template>
    <div class="template-default vertical-layout">
        <div class="top fixed-top">
            <div :class="isMobile ? '' : 'container'">
                <div class="d-flex justify-content-between">
                    <div>
                        <Logo class="pt-1"/>
                    </div>
                    <div class="position-relative">
                        <ArrowBreadcrumbs :title="titleToShow" @open="onOpen"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <main>
                <div class="d-flex justify-content-around pt-4">
                    <div class="content">
                        <slot></slot>
                    </div>
                    <div class="sidebar">
                        <slot name="sidebar"></slot>
                    </div>
                </div>
            </main>
        </div>
        <footer>
            <Footer/>
            <slot name="footer"></slot>
        </footer>
    </div>
</template>

<script>
import Navbar from './default/Navbar'
import Logo from '../../pages/layout/default/Logo'
import Footer from './common/Footer'
import WarningImplementation from '../../common/WarningImplementation'
import ArrowBreadcrumbs from '../../widgets/common/ArrowBreadcrumbs'
import MobileDetector from '../../common/MobileDetector'
import ConfigUtils from '../../utils/ConfigUtils'

export default {
  name: 'DefaultLayout',
  mixins: [MobileDetector, ConfigUtils],
  components: {ArrowBreadcrumbs, WarningImplementation, Footer, Logo, Navbar},
  props: {
    title: String
  },
  computed: {
    titleToShow () {
      if (!this.TITLE_IS_PROJECT) {
        return this.title
      } else {
        return this.PROJECT_NAME
      }
    }
  },
  methods: {
    onOpen (event) {
      this.$emit('open', event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/pages/layout/DefaultLayout.vue